import { Dictionary } from "flow/api/types";

const store: Dictionary = {
    "en-GB": "en",
    "sv-SE": "sv_SE",
    "sv-FI": "sv_SE",
    "fi-FI": "fi",
    "nb-NO": "nb_NO"
};

function get(key: string): string {
    return lookup(key, "en");
}

function lookup(key: string, defaultValue: string): string {
    if (!key) {
        return defaultValue;
    }

    return store[key] || defaultValue;
}

export default {
    get: get
};
